// ✅ Componente React — WellnessVsCargaChart.jsx
// Mismo patron que PMCChart (Recharts), con eje Y secundario para el delta
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';

const ESTADO_COLOR = {
  alerta: '#dc2626',
  vigilar: '#d97706',
  ok: '#16a34a',
  sin_datos: '#94a3b8',
};

/**
 * data: arreglo de { date, tsb, delta } — viene de
 *   GET /wellness-vs-carga/:athleteId?start=...&end=...
 * estado: 'alerta' | 'vigilar' | 'ok' — para colorear la linea de delta
 */
const WellnessVsCargaChart = ({ data, estado = 'ok' }) => {
  const deltaColor = ESTADO_COLOR[estado] || ESTADO_COLOR.ok;

  return (
    <ResponsiveContainer width="100%" height={260}>
      <LineChart data={data}>
        <XAxis dataKey="date" tick={{ fontSize: 10 }} />
        <YAxis yAxisId="tsb" tick={{ fontSize: 10 }} label={{ value: 'TSB', angle: -90, position: 'insideLeft', fontSize: 10 }} />
        <YAxis
          yAxisId="delta"
          orientation="right"
          domain={[-10, 5]}
          tick={{ fontSize: 10 }}
          label={{ value: 'Δ Wellness', angle: 90, position: 'insideRight', fontSize: 10 }}
        />
        <Tooltip />
        <Legend />
        <ReferenceLine yAxisId="delta" y={0} stroke="#cbd5e1" />
        <Line
          yAxisId="tsb"
          type="monotone"
          dataKey="tsb"
          stroke="#185fa5"
          strokeWidth={2.5}
          name="TSB (modelo)"
          dot={{ r: 3 }}
        />
        <Line
          yAxisId="delta"
          type="monotone"
          dataKey="delta"
          stroke={deltaColor}
          strokeWidth={2.5}
          name="Delta wellness"
          dot={{ r: 3 }}
          connectNulls
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default WellnessVsCargaChart;
